<template>
    <div class="detail-shell">
        <div class="container" v-loading="loading">
<!--          <img style="position: absolute;right: 10px;top: 5px" :src="require('@/assets/'+data.picStatus+'.png')" height="117" width="134"/>-->
          <el-row :gutter="24">
                <el-row>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">报告防伪编码</div>
                            <div class="value">{{data.libraryCodeNum?data.libraryCodeNum:'暂无数据'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">报告文号</div>
                            <div class="value">{{data.libraryNum?data.libraryNum:'暂无数据'}}</div>
                        </div>

                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">被审计单位名称</div>
                            <div class="value" style="width: 80%">{{data.companyTitle?data.companyTitle:'暂无数据'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">标题</div>
                            <div class="value">{{data.title?data.title:'暂无数据'}}</div>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">报备类型</div>
                            <div class="value">{{data.filingTypeTitle?data.filingTypeTitle:'暂无数据'}}</div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">报告属期</div>
                            <div class="value">{{data.auditStartTime}} 至 {{data.auditEndTime}}</div>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <div class="item-box">
                            <div class="label">签字注册会计师</div>
                            <div class="value" style="display: flex;align-items: flex-start;margin-bottom: 10px" :key="index" v-for="(item,index) in data.accountant">
                                <span style="flex: .4">{{item.name}}</span>
                                <span style="flex: .6;font-size: 16px">{{item.num}}</span>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="item-box">
                        <div class="label">事务所</div>
                        <div class="value" style="margin-bottom: 10px">{{data.officeCompanyTitle?data.officeCompanyTitle:'暂无数据'}}</div>
                        <div class="value" style="margin-bottom: 10px">{{data.phone?data.phone:'暂无数据'}}</div>
                        <div class="value" style="margin-bottom: 10px">{{data.address?data.address:'暂无数据'}}</div>
                      </div>
                    </el-col>
                </el-row>
            </el-row>
        </div>
    </div>

</template>

<script>
// @ is an alias to /src

export default {
  name: 'Detail',
  components: {

  },
  mounted(){
    // window.onresize =  ()=> {
    //   this.style.width = '100%'
    //   this.style.height = '100%'
    // }
  },
  data(){
    return{
      loading:false,
      icons:{
        status1:require('@/assets/1.png'),
        status2:require('@/assets/2.png'),
        status3:require('@/assets/4.png'),
        status4:require('@/assets/3.png')
      }
    }
  },
  computed:{
    data(){
      return this.$store.getters.getLibraryInfo
    }
  },
  methods:{

  }
}
</script>
<style lang="scss" scoped>
    .detail-shell{
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        background-color: #f6f6f6;
    }
    .container{
        width:90%;
        height: 85%;
        overflow-y: auto;
        position: relative;
        background-color: #fff;
        border-top: 18px solid #1366E3;
        padding: 7vh clamp(32px, 7vw, 150px);
        .item-box{
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            margin-bottom: 60px ;
            width: 100%;
        }
        .label{
            color: #999;
            font-size: 20px;
            margin-bottom: 15px;
        }
        .value{
            width: 100%;
            color: #333;
            font-size:20px;
        }
    }
    @media (max-width: 1200px) {
        .container { width: 94%; padding: 48px 32px; }
    }
</style>
